import { DateInput } from "./DateInput";

const TIMES = Array.from({ length: 96 }, (_, i) => `${String(Math.floor(i / 4)).padStart(2, "0")}:${String((i % 4) * 15).padStart(2, "0")}`);

// Valeur "AAAA-MM-JJTHH:MM" (heure de Paris) ou "" ; date seule = 00h00 (23h59 pour une fin)
export const ScheduleInput = ({ value, onChange, testid, endOfDay = false }) => {
  const [d, t] = (value || "").split("T");
  const def = endOfDay ? "23:59" : "00:00";
  const times = endOfDay ? [...TIMES, "23:59"] : TIMES;
  const emit = (date, time) => onChange(date ? `${date}T${time || def}` : "");
  return (
    <div className="flex items-center gap-2">
      <DateInput value={d || ""} onChange={(e) => emit(e.target.value, t)} className="w-36" data-testid={`${testid}-date`} />
      <select value={t || def} disabled={!d} onChange={(e) => emit(d, e.target.value)} data-testid={`${testid}-time`}
        className="border border-slate-300 rounded-md px-2 py-1.5 text-sm disabled:opacity-40">
        {times.map((x) => <option key={x} value={x}>{x.replace(":", "h")}</option>)}
      </select>
      {d && <button type="button" onClick={() => onChange("")} data-testid={`${testid}-clear`} className="text-xs text-slate-500 hover:text-rose-600">Effacer</button>}
    </div>
  );
};
